<div style="padding: 24px;text-align: center;background: #161616;border-radius: 5px;">
    <div style="font-size:18px;font-weight:700;color: #dedede;">Review Confirmation</div>
    <div style="margin-top:8px;margin-bottom:16px;color: #dedede;opacity: 0.7;font-size:14px">Do you confirm all the
        information on this project is up to date?</div>
    <div style="display: flex; justify-content: center">
        <button mat-button (click)="cancel()"
            style="background: #161616;border-radius: 4px;margin-right: 10px;width: 163px;height: 52px;border: 1px solid rgba(222, 222, 222, 0.4);color: rgba(222, 222, 222, 0.4);">Cancel</button>
        <button mat-button (click)="manulUpdateProject()"
            style="background: #d13f2f; color: white;background: #161616;border-radius: 4px;width: 163px;height: 52px;border: 1px solid #dedede;color: #dedede;">Confirm</button>
    </div>
</div>